import * as types from '../actions/actionTypes';
import initialState from './initialState';
import store from 'store';

export default function authenticationReducer(state = initialState.auth, action){
    let userObject = {};
    switch(action.type){
      case types.LOGIN_USER_SUCCESS:
        store.set('topicToken', action.token);
        return Object.assign({}, state, {isLoggedIn: true});
      case types.LOGOUT_USER_SUCCESS:
        store.remove('topicToken');
        store.remove('adthriveAuthObj');
        return Object.assign({}, state, {isLoggedIn: false, isLoggedInAdthrive: false, adthriveSites: [], activeSite: null});
      case types.LOGIN_ADTHRIVE_USER_SUCCESS:
        store.set('adthriveAuthObj', {
          token: action.token,
          email: action.email,
          name: action.name
        });
        return Object.assign({}, state, {isLoggedInAdthrive: true, token: action.token, email: action.email, name: action.name});
      case types.SET_ADTHRIVE_SITES:
        return Object.assign({}, state, {adthriveSites: action.sites});
      case types.SET_ACTIVE_SITE:
        store.set('adthriveActiveSite', action.site);
        return Object.assign({}, state, {activeSite: action.site});
      default:
        return state;
    }
}
